module.exports = __webpack_public_path__ + "static/media/pink-ok.84185385.png";